import { createSlice } from '@reduxjs/toolkit';

const categorySlice = createSlice({
  name: 'category',
  initialState: {
    count:0,
    limit:0,
    records:[]
  },
  reducers: {
    addCategory: (state, action) => {
      return action.payload
    }
  },
});

export const { addCategory } = categorySlice.actions;
export default categorySlice.reducer;
